import HttpRequest from './HttpRequest'

class ProportionOfSeparateComplaintsChannelProvider extends HttpRequest {
  findAll (query) {
    return this.get('/proportion-of-separate-complaints-channel/', query)
  }
}

export default ProportionOfSeparateComplaintsChannelProvider
